export const updatedMaterials = (
  materials:
    | { images?: { variant: string; link: string }[] }
    | null
    | undefined,
  variantId?: string,
  newPhotoLink?: string,
) => {
  if (!materials || !variantId || !newPhotoLink) return materials;

  const updatedImages = materials.images?.map((image) =>
    image.variant === variantId ? { ...image, link: newPhotoLink } : image,
  );

  return {
    ...materials,
    images: updatedImages ?? materials.images,
  };
};
